import {customElement, DOM, observable} from '@genesislcap/web-core';
import { HelpDialogTempate as template } from './help-dialog.template';
import { HelpDialogStyles as styles } from './help-dialog.styles';
import { FoundationElement } from '@genesislcap/web-core';
import { Modal } from '@genesislcap/foundation-ui';
import { Button as ZeroButton } from '@genesislcap/foundation-zero';
import { Auth } from '@genesislcap/foundation-comms';

const name = 'help-dialog';

declare let GENX_BUILD_INFO: string;

const BUILD_INFO = typeof GENX_BUILD_INFO !== 'undefined' ? GENX_BUILD_INFO : 'N/A';

@customElement({
  name,
  template,
  styles,
})
export class HelpDialog extends FoundationElement {
  @observable closeButton: ZeroButton;
  @Auth auth!: Auth;

  public modal: Modal;
  @observable isHidden: string;

  buildInfo: string = BUILD_INFO

  public show() {
    this.modal.show();
  }

  public close() {
    this.modal.close();
  }

  public getEncodedSubject() {
    const subject = 'Municipal Bonds Institutional Trading Portal';
    let encodedSubject = encodeURI(subject);
    return encodedSubject;
  }

  public getEncodedBody() {
    const body = 'Hi support,\n\nI am using the Municipal Bonds portal and have the following query:\n\n\n\nKind regards\n' + this.auth.currentUser.userName +'\n';
    let encodedBody = encodeURI(body);
    return encodedBody;
  }
}
